import { Button, Result } from 'antd'
import { tokens } from '../theme/tokens'

interface Props {
  error: unknown
  resetError: () => void
}

export default function ErrorFallback({ error, resetError }: Props) {
  const msg = (error instanceof Error ? error.message : String(error || '')).slice(0, 200)
  return (
    <Result
      status="error"
      title="页面崩溃了"
      subTitle="错误已自动上报技术。可点下方按钮重试当前页面, 或刷新整个网页。"
      extra={[
        <Button key="retry" type="primary" onClick={resetError}>
          重试
        </Button>,
        <Button key="reload" onClick={() => window.location.reload()}>
          刷新整页
        </Button>,
      ]}
    >
      {msg && (
        <pre style={{ margin: 0, fontSize: 12, color: tokens.colors.textSecondary, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
          {msg}
        </pre>
      )}
    </Result>
  )
}
